import _ from 'lodash';
import api from '../api';

const state = {
    data: {},
    meta: {}
};

const actions = {
    init: async ({}, data) => {
        if (!data?.contentstreamId) {
            return;
        }
        let apiUrl = 'contentstreams/users/status/init?contentstream_id=' + data.contentstreamId;

        if (data.isRead !== undefined && data.isRead !== null) {
            apiUrl += '&is_read=' + data.isRead;
        }
        if (data.isFavorite !== undefined && data.isFavorite !== null) {
            apiUrl += '&is_favorite=' + data.isFavorite;
        }

        return await api
            .patch(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    update: async ({}, data) => {
        let apiUrl = 'contentstreams/users/status?user_id=' + data.userId + '&contentstream_id=' + data.contentstreamId;

        if (!_.isUndefined(data.isRead)) {
            apiUrl += '&is_read=' + data.isRead;
        }
        if (!_.isUndefined(data.isFavorite)) {
            apiUrl += '&is_favorite=' + data.isFavorite;
        }

        return await api
            .patch(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    markAllAsRead: async ({}, data) => {
        let apiUrl = 'contentstreams/users/status/all/read?user_id=' + data.userId;

        return await api
            .patch(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },

    fetch: async ({}, data) => {
        let apiUrl = 'contentstreams/users/status?user_id=' + data.userId + '&contentstream_id=' + data.contentstreamId;

        return await api
            .get(`/api/v1/${apiUrl}`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    },
    getAll: async ({ commit }, config) => {
        return await api
            .get(`/api/v1/contentstreams/users/favorite/all`, config)
            .then((response) => {
                commit('set', response);
                return response.data;
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            });
    }
};

const mutations = {
    set(state, data) {
        state.data = data.data;
        state.meta = data.meta;
    }
};

const getters = {
    get: (state) => {
        return state.data;
    },
    getMeta: (state) => {
        return state.meta;
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
